import clsx from "clsx";
import Styles from "./index.module.scss";

export const ClientTransactionTable = ({ columns, data, total }) => {
  return (
    <div className={clsx(Styles.tableWrapper)}>
      <table className={clsx(Styles.table)}>
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index}>{column.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => (
                <td key={colIndex}>
                  {column.render ? column.render(row) : row[column.key] ?? ""}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
